export const USER_SERVICE_ENDPOINT = window.env.VUE_APP_USER_SERVICE_DOMAIN;

// Resource paths
export const ORGANIZATION_RESOURCE_PATH = '/organisation';
export const USER_RESOURCE_PATH = '/user';
